// src/components/admin/PermissionNode.jsx
import styled from "styled-components";

const NodeRow = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 6px;
  margin-bottom: 2px;
  border-radius: 4px;
  transition: background 0.1s ease;
  &:hover {
    background: #f8fafc;
  }
`;

const ExpanderBtn = styled.button`
  background: none;
  border: none;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
  font-size: 14px;
  padding: 0;
  &:hover {
    color: #2563eb;
  }
`;

const EmptyExpander = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

const NodeText = styled.span`
  font-size: 11px;
  font-weight: ${(p) => (p.$isModule ? "600" : "500")};
  color: ${(p) => (p.$isModule ? "#1e293b" : "#475569")};
  user-select: none;
  cursor: pointer;
`;

const Checkbox = styled.input`
  margin: 0 8px;
  cursor: pointer;
`;

const ChildContainer = styled.div`
  margin-left: ${(p) => (p.$level === 0 ? 10 : 22)}px;
  padding-left: ${(p) => (p.$level === 0 ? 12 : 8)}px;
  border-left: 1px dashed #cbd5e1;
  margin-bottom: 6px;
`;

export default function PermissionNode({
  node,
  level,
  checked,
  expanded,
  onToggleModule,
  onToggleAction,
  onToggleExpand,
  parentStack,
}) {
  const isExpanded = expanded.get(`mod-${node.id_modulo}`);
  const isChecked = checked.get(`mod-${node.id_modulo}`);
  const hasChildren = node.children?.length > 0 || node.acciones?.length > 0;

  return (
    <div>
      {/* -------------------------------
          LÍNEA PRINCIPAL DEL MÓDULO
      --------------------------------*/}
      <NodeRow style={{ marginLeft: level * 12 }}>
        {hasChildren ? (
          <ExpanderBtn onClick={() => onToggleExpand(node.id_modulo)}>
            {isExpanded ? "▾" : "▸"}
          </ExpanderBtn>
        ) : (
          <EmptyExpander />
        )}

        <Checkbox
          type="checkbox"
          checked={isChecked || false}
          onChange={() => onToggleModule(node)}
        />

        <NodeText $isModule={true} onClick={() => onToggleModule(node)}>
          {node.nombre}
        </NodeText>
      </NodeRow>

      {/* -------------------------------
          CONTENIDO EXPANDIDO
      --------------------------------*/}
      {isExpanded && hasChildren && (
        <ChildContainer $level={level}>
          {/* --- ACCIONES --- */}
          {node.acciones?.map((acc) => (
             <NodeRow key={acc.id_accion} style={{ marginLeft: 0 }}>
               <EmptyExpander />
               <Checkbox
                 type="checkbox"
                 checked={checked.get(`acc-${acc.id_accion}`) || false}
                 onChange={() => onToggleAction(acc, [...parentStack, node])}
               />
               <NodeText $isModule={false} onClick={() => onToggleAction(acc, [...parentStack, node])}>
                 {acc.nombre}
               </NodeText>
             </NodeRow>
          ))}

          {/* --- SUBMÓDULOS --- */}
          {node.children?.map((child) => (
            <PermissionNode
              key={child.id_modulo}
              node={child}
              level={level + 1}
              checked={checked}
              expanded={expanded}
              onToggleModule={onToggleModule}
              onToggleAction={onToggleAction}
              onToggleExpand={onToggleExpand}
              parentStack={[...parentStack, node]}
            />
          ))}
        </ChildContainer>
      )}
    </div>
  );
}
